const COPY_ATTACHED_ATTR = 'data-copy-attached'

function extractHighlightText(highlight: HTMLElement): string {
  const lineNumberPre = highlight.querySelector('.highlighttable .code pre')
  const pre = lineNumberPre ?? highlight.querySelector(':scope > pre')
  if (!pre) {
    return ''
  }

  const clone = pre.cloneNode(true) as HTMLElement
  clone.querySelectorAll('a[name^="__codelineno"], a[id^="__codelineno"]').forEach((node) => node.remove())
  return (clone.textContent ?? '').replace(/\n$/, '')
}

function markHighlightProcessed(highlight: HTMLElement): void {
  highlight.setAttribute(COPY_ATTACHED_ATTR, 'true')
}

export function attachDocsCodeCopyButtons(root: HTMLElement, onCopied: () => void): void {
  const highlights = root.querySelectorAll<HTMLElement>(`.highlight:not([${COPY_ATTACHED_ATTR}])`)

  highlights.forEach((highlight) => {
    if (highlight.querySelector('pre.mermaid')) {
      markHighlightProcessed(highlight)
      return
    }

    markHighlightProcessed(highlight)

    const button = document.createElement('button')
    button.type = 'button'
    button.className = 'docs-code-copy-btn'
    button.setAttribute('aria-label', 'Copy code')
    button.title = 'Copy code'
    button.textContent = 'Copy'

    button.addEventListener('click', (event) => {
      event.preventDefault()
      event.stopPropagation()

      const text = extractHighlightText(highlight)
      if (!text) {
        return
      }

      void navigator.clipboard.writeText(text).then(onCopied).catch(() => undefined)
    })

    highlight.appendChild(button)
  })
}
